import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NavBarLateral } from "../NavBarLateral";
import alertService from "../../../_services/cart/alert.service";
import facturacionService, {
    estadoFacturaLabel, fechaFactura, importeFactura, letra, mensajeDeError, numeroFormateado,
} from "../../../_services/cart/facturacion.service";

/**
 * Facturas emitidas por la cuenta. En tienda-admin el servicio de facturas existe pero no tiene pantalla
 * ("todavia no esta cableado"), asi que esta es nueva: el listado con el estilo de "Mi plan", y las acciones
 * que el servicio ya ofrecia (PDF, reintentar las que no llegaron a ARCA).
 *
 * Solo aparece en el menu con ARCA integrado y probado.
 */

const PAGE_SIZE = 20;

const claseEstado = (estado) => {
    switch (estado) {
        case "EMITIDA": return "arca__pill arca__pill--ok";
        case "BORRADOR": return "arca__pill arca__pill--warn";
        case "RECHAZADA": return "arca__pill arca__pill--error";
        default: return "arca__pill";
    }
};

export const FacturasCuenta = () => {
    const [pagina, setPagina] = useState(null);
    const [page, setPage] = useState(0);
    const [busqueda, setBusqueda] = useState("");
    const [filtro, setFiltro] = useState("");
    const [cargando, setCargando] = useState(true);
    const [trabajando, setTrabajando] = useState(null);

    const cargar = () => {
        setCargando(true);
        facturacionService.buscar({ page, pageSize: PAGE_SIZE, searchValue: filtro || undefined })
            .then(setPagina)
            .catch((err) => alertService.msg(mensajeDeError(err, "No se pudieron cargar las facturas"), "error"))
            .finally(() => setCargando(false));
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(cargar, [page, filtro]);

    const buscar = (e) => {
        e.preventDefault();
        setPage(0);
        setFiltro(busqueda.trim());
    };

    const pdf = (f) => {
        setTrabajando(f.id);
        facturacionService.descargarPdf(f)
            .catch((err) => alertService.msg(mensajeDeError(err, "No se pudo descargar el PDF"), "error"))
            .finally(() => setTrabajando(null));
    };

    const reintentar = (f) => {
        setTrabajando(f.id);
        facturacionService.reintentar(f.id)
            .then((r) => {
                if (r.estado === "EMITIDA") alertService.msg(`Factura ${letra(r)} ${numeroFormateado(r)} emitida`, "success");
                else alertService.msg(r.erroresAfip || "ARCA no aprobó la factura", "error");
                cargar();
            })
            .catch((err) => alertService.msg(mensajeDeError(err, "No se pudo reintentar"), "error"))
            .finally(() => setTrabajando(null));
    };

    const facturas = pagina?.content || [];

    return (
        <div className="dashboard">
            <NavBarLateral handleClose={() => {}} />

            <div className="dashboard__content cuenta-usuarios">
                <div className="dashboard__content-header cuenta-usuarios__header">
                    <div className="dashboard__content-title">
                        <p className="cuenta-usuarios__eyebrow">VENDER</p>
                        <h2>Facturas</h2>
                        <p className="panel__bajada">Los comprobantes que emitiste con ARCA. Se factura desde el detalle de cada venta.</p>
                    </div>
                    <form className="cuenta-usuarios__buscador" onSubmit={buscar}>
                        <input type="text" value={busqueda} onChange={(e) => setBusqueda(e.target.value)} placeholder="Cliente, documento o CAE" />
                        <button type="submit" className="button" data-type="secondary">
                            <FontAwesomeIcon icon="fa-solid fa-magnifying-glass" />
                        </button>
                    </form>
                </div>

                {cargando && !pagina && <p className="panel__estado-carga">Cargando…</p>}

                {pagina && facturas.length === 0 && (
                    <div className="cuenta-usuarios__card">
                        <p className="arca__nota">
                            {filtro ? "No hay facturas que coincidan con la búsqueda." : "Todavía no emitiste facturas. Entrá a una venta pagada y tocá \"Facturar\"."}
                        </p>
                    </div>
                )}

                {facturas.length > 0 && (
                    <div className="cuenta-usuarios__card cuenta-usuarios__tabla-card">
                        <div className="facturas__tabla">
                            <div className="facturas__fila facturas__fila--head">
                                <span>Fecha</span>
                                <span>Comprobante</span>
                                <span>Cliente</span>
                                <span className="facturas__num">Total</span>
                                <span>Estado</span>
                                <span />
                            </div>
                            {facturas.map((f) => (
                                <div className="facturas__fila" key={f.id}>
                                    <span data-label="Fecha">{fechaFactura(f.fechaEmision)}</span>
                                    <span data-label="Comprobante">
                                        <strong>{letra(f) ? `Factura ${letra(f)}` : f.tipoComprobante}</strong> {numeroFormateado(f)}
                                        {f.cae && <small className="facturas__sub">CAE {f.cae}</small>}
                                    </span>
                                    <span data-label="Cliente">
                                        {f.receptorRazonSocial}
                                        <small className="facturas__sub">
                                            {f.receptorDocTipo === "CONSUMIDOR_FINAL" ? "Consumidor final" : `${f.receptorDocTipo} ${f.receptorDocNro}`}
                                            {f.ventaId && <> · <Link to={`/comprador/compraDetail?id=${f.ventaId}`}>Venta #{f.ventaId}</Link></>}
                                        </small>
                                    </span>
                                    <span data-label="Total" className="facturas__num">{importeFactura(f.importeTotal)}</span>
                                    <span data-label="Estado">
                                        <span className={claseEstado(f.estado)}><span /> {estadoFacturaLabel(f.estado)}</span>
                                        {f.estado === "EMITIDA" && f.mailEstado === "ERROR" && <small className="facturas__sub">No se pudo mandar el mail</small>}
                                        {f.estado !== "EMITIDA" && f.erroresAfip && <small className="facturas__sub facturas__error">{f.erroresAfip}</small>}
                                    </span>
                                    <span className="facturas__acciones">
                                        {f.estado === "EMITIDA" && (
                                            <button type="button" className="cuenta-usuarios__icono" title="Descargar PDF" onClick={() => pdf(f)} disabled={trabajando === f.id}>
                                                <FontAwesomeIcon icon="fa-solid fa-file-pdf" />
                                            </button>
                                        )}
                                        {f.estado === "BORRADOR" && (
                                            <button type="button" className="button" data-type="secondary" onClick={() => reintentar(f)} disabled={trabajando === f.id}>
                                                {trabajando === f.id ? "Enviando…" : "Reintentar"}
                                            </button>
                                        )}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {pagina && pagina.totalPages > 1 && (
                    <div className="facturas__paginado">
                        <button type="button" className="button" data-type="secondary" disabled={page === 0} onClick={() => setPage(page - 1)}>
                            <FontAwesomeIcon icon="fa-solid fa-arrow-left" />
                        </button>
                        <span>Página {page + 1} de {pagina.totalPages}</span>
                        <button type="button" className="button" data-type="secondary" disabled={page >= pagina.totalPages - 1} onClick={() => setPage(page + 1)}>
                            <FontAwesomeIcon icon="fa-solid fa-arrow-right" />
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};
